(function(){
  if(window.__sppCartRefinementsV3Loaded) return;
  window.__sppCartRefinementsV3Loaded = true;

  var labels = ['Secure Checkout','Easy Returns','Free Delivery*','Safe Payments'];

  function setBadgeLabel(badge, label){
    if(!badge || !label) return;
    var textNode = Array.prototype.find.call(badge.childNodes, function(node){
      return node.nodeType === Node.TEXT_NODE && (node.nodeValue || '').trim();
    });
    if(textNode){
      if((textNode.nodeValue || '').trim() !== label) textNode.nodeValue = ' ' + label + ' ';
      return;
    }
    var span = badge.querySelector('.spp-v3-badge-label');
    if(!span){
      span = document.createElement('span');
      span.className = 'spp-v3-badge-label';
      badge.appendChild(span);
    }
    if(span.textContent !== label) span.textContent = label;
  }

  function apply(){
    var footer = document.querySelector('#main-cart-footer');
    if(!footer) return;

    footer.querySelectorAll('.spp-cart-badge').forEach(function(badge, index){
      if(labels[index]) setBadgeLabel(badge, labels[index]);
    });
  }

  function ready(){
    apply();
    var footer = document.querySelector('#main-cart-footer');
    if(!footer) return;
    var queued = false;
    new MutationObserver(function(){
      if(queued) return;
      queued = true;
      requestAnimationFrame(function(){
        queued = false;
        apply();
      });
    }).observe(footer,{childList:true,subtree:true,characterData:true});
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
})();
